import { render, staticRenderFns } from "./HighlightedAboutUs.vue?vue&type=template&id=ecf3c4e6&scoped=true&"
import script from "./HighlightedAboutUs.vue?vue&type=script&lang=js&"
export * from "./HighlightedAboutUs.vue?vue&type=script&lang=js&"
import style0 from "./HighlightedAboutUs.vue?vue&type=style&index=0&id=ecf3c4e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf3c4e6",
  null
  
)

export default component.exports